<script setup lang="ts">
import { Modification } from '@/types/api/api-v3/product'
import type { ProductV5Modification } from '@/types/api/api-v5/product'

type Props = {
  currentModificationId: number
  modifications: Modification[] | ProductV5Modification[]
}

defineProps<Props>()

const emit = defineEmits(['changeModification'])

const { isDesktop } = useDevice()

const tabsSize = computed(() => (isDesktop ? 'md' : 'sm'))

const changeModification = (modificationId: number) => {
  emit('changeModification', modificationId)
}
</script>

<template>
  <the-tabs
    class="modification__tabs"
    :size="tabsSize"
    :model-value="currentModificationId"
  >
    <the-tabs-item
      v-for="modification in modifications"
      :key="modification.id"
      :value="modification.id"
      @click="changeModification(modification.id)"
    >
      {{ modification.mode }}
    </the-tabs-item>
  </the-tabs>
</template>

<style lang="scss" scoped>
.modification__tabs {
  max-width: 100%;
}
</style>
